<template>
  <div>
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <h2 class="mb-1">Certifications ({{exams.length}})</h2>

    <AppLoader v-if="isLoading" class="text-center" small />
    <b-row class="ml-2 mt-2 mr-2" style="height: calc(100vh - 200px); overflow:auto;">
      <b-col cols="3" v-for="(exam, index) in exams" :key="index">
        <b-card bg-variant="default" class="mb-2" style="height:400px;">
          <b-card-text class="my-3">
            <font-awesome-icon icon="certificate" size="5x" style="color:#3DDC97;" />
          </b-card-text>
          <b-card-text>{{exam.task_title}}</b-card-text>

          <b-card-text>Number Questions: {{getNumberOfExamQuestions(exam.schema)}}</b-card-text>
          <b-card-text v-if="getExamTime(exam) > 0">Exam Time: {{getExamTime(exam)}} Mins</b-card-text>
          <b-card-text
            v-if="!JSON.parse(exam.schema).formConfiguration.exam.isUnlimitedAttempts"
          >Maximum Attempts: {{getExamTotalAttempts(exam)}}</b-card-text>
          <!-- <b-card-text v-if="exam.exam_attempts_count>0"><b-badge variant="danger">Failed Attempts: </b-badge> {{exam.exam_attempts_count}}</b-card-text> -->
          <b-card-text
            v-if="!JSON.parse(exam.schema).formConfiguration.exam.isUnlimitedAttempts"
          >
            <template v-for="(badge, badgeIndex) in getExamStatus(exam)">
              <br v-if="badgeIndex > 0" :key="'br-' + badgeIndex" />
              <span :key="badgeIndex" :class="'badge badge-' + badge.variant">{{ badge.text }}</span>
            </template>
          </b-card-text>

          <b-button
            v-if="exam.task_status !=4 && (exam.exam_attempts_count != JSON.parse(exam.schema).formConfiguration.exam.examMaxLimit) || (!examStatus(exam) && exam.task_status !=4) || (exam.task_status != 4)"
            class="mr-2"
            variant="outline-primary"
            @click="getTaskForm(exam.form_id,exam.type,exam.id)"
          >{{ getButtonStatus(exam) }}</b-button>

          <b-button
            v-if="examStatus(exam)"
            variant="outline-dark"
            @click="downloadPdf(exam.id,'/download/certificate')"
          >
            <font-awesome-icon icon="file-pdf" />
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import config from "./../configs/config";
import AppLoader from "../components/Loader/Loader";
import { Helper } from "../helpers";
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { HTTP } from "../utils/HTTP";
export default {
  name: "MyTPPPage",
  components: {
    AppLoader
  },
  data() {
    return {
      exams: [],
      formButtom: false,
      breadcrumbs: [
        {
          text: "Dashboard",
          // href: "/dashboard"
          href: "/onboarding/dashboard"
        },

        {
          text: "Certifications",
          active: true
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
      userFormSubmitArray: "userFormSubmitArray"
    }),
    rows() {
      return this.totalRows;
    }
  },
  beforeMount() {
    this.getTasks();
  },

  beforeRouteLeave(to, from, next) {
    if (this.formButtom) {
      next();
    } else if (to.name == "dashboard-third-party" || to.name == "login") {
      next();
    } else {
      next(false);
    }
  },

  mounted() {},

  methods: {
    getPdfStatus(attempts) {
      let status = attempts.find(attempt => {
        if (attempt.result == 1) {
          return true;
        } else {
          return false;
        }
      });
      return false;
    },

    makeToast() {
      const h = this.$createElement;
      const vNodesMsg = h("p", { class: ["text-center", "mb-0"] }, [
        h("b-spinner", { props: { type: "grow", small: true } }),
        " We are generating your PDF... ",
        h("b-spinner", { props: { type: "grow", small: true } })
      ]);
      this.$bvToast.toast([vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 3000
      });
    },

    async downloadPdf(taskId, route) {
      this.makeToast();
      axios({
        url: config.API_URL + "v1/mytpp" + route + "/" + taskId,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        },
        data: {}
      })
        .then(response => {
          const link = document.createElement("a");
          let fileName = "certicate.pdf";
          let blob = new Blob([response.data]);
          //Download for IE11 as Blob isn't supported
          if (window.navigator.msSaveOrOpenBlob) {
            link.addEventListener("click", function() {
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            });
          } else {
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute("download", fileName); //or any other extension
          }
          document.body.appendChild(link);
          link.click();
          Helper.makeToast(
            this.$bvToast,
            "success",
            "PDF download successfully"
          );
        })
        .catch(error => {
          Helper.makeToast(
            this.$bvToast,
            "danger",
            "PDF not downloaded please try again"
          );
        });
    },

    examStatus(exam) {
      let statusText = false;
      let status = exam.exam_attempts.find(attempt => {
        if (attempt.result == 1) {
          statusText = true;
          return;
        } else {
          statusText = false;
          return;
        }
      });

      return statusText;
    },

    getButtonStatus(exam) {
      let statusText = "Try Again";
      if (exam.exam_attempts_count == 0) {
        statusText = "Start";
      } else if (
        exam.exam_attempts_count <
          JSON.parse(exam.schema).formConfiguration.exam.examMaxAttempts &&
        exam.task_status != 4
      ) {
        statusText = "Try Again";
      } else if (
        exam.exam_attempts_count ==
          JSON.parse(exam.schema).formConfiguration.exam.examMaxAttempts &&
        exam.task_status == 4
      ) {
        statusText = "Failed";
      }

      return statusText;
    },

    getTaskFormType(value) {
      let type = "Questionniare";
      if (value == 2) {
        type = "Survey";
      } else if (value == 3) {
        type = "Training";
      } else if (value == 4) {
        type = "Exam";
      }
      return type;
    },

    getExamTime(data) {
      let schema = JSON.parse(data.schema);
      if (schema.formConfiguration && schema.formConfiguration.exam) {
        return schema.formConfiguration.exam.examTimeLimit || 0;
      } else {
        return 0;
      }
    },

    getNumberOfExamQuestions(data) {
      let schema = JSON.parse(data);
	  // // console.log(schema);
// return schema.formSection[0].formElements.length   
      if (schema.formConfiguration)
        return schema.formConfiguration.exam.examUniqueAnswersPerAttempt
          ? schema.formConfiguration.exam.examUniqueAnswersPerAttempt
          : 0;
    },

    getExamTotalAttempts(data) {
      let schema = JSON.parse(data.schema);
      if (schema.formConfiguration && schema.formConfiguration.exam) {
        return schema.formConfiguration.exam.examMaxAttempts;
      } else {
        return 0;
      }
    },

    getExamStatus(exam) {
      let schema = JSON.parse(exam.schema);

      let remaining =
        parseInt(schema.formConfiguration.exam.examMaxAttempts) -
        parseInt(exam.exam_attempts_count);
      let badges = [
        { variant: "dark", text: remaining + " attempt(s) remaining" },
      ];

      if (schema.formConfiguration && schema.formConfiguration.exam) {
        if (parseInt(exam.task_status) == 4 && this.examStatus(exam)) {
          badges = [{ variant: "success", text: "PASSED" }];
        } else if (
          parseInt(exam.task_status) == 4 &&
          remaining == 0 &&
          !this.examStatus(exam)
        ) {
          badges = [
            { variant: "dark", text: remaining + " attempt(s) remaining" },
            { variant: "warning", text: "FAILED" },
          ];
        } else if (parseInt(exam.task_status) != 4 && remaining > 0) {
          badges = [
            { variant: "dark", text: remaining + " attempt(s) remaining" },
          ];
        }
      }
      return badges;
    },

    age(value) {
      let localeData = moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "hello, a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        }
      });
      //return moment(value).fromNow();

      return moment(value).fromNow();
    },

    async getTasks() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let userId = localStorage.getItem("userId");
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/tasks",
          {
            userId: userId
          },

          {
            Authorization: token
          },
          null,
          true
        );
        this.exams = result.data.exams;
      } catch (error) {}
    },

    async getTaskForm(formId, formType, taskId) {
      this.formButtom = true;
      localStorage.removeItem("taskId");
      localStorage.removeItem("activeFormId");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("taskFormData");
      localStorage.removeItem("activeTaskStatus");
      localStorage.setItem("taskId", taskId);
      let userId = localStorage.getItem("userId");
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP(
        "post",
        "v1/mytpp/task/" + taskId,
        {
          userId: userId,
          formType: formType
        },
        {
          Authorization: token
        },
        null,
        true
      );

      if (result.data.task && result.data.task) {
        // alert(result.data.task.task_status);
        let form = result.data.task.form.schema;
        let form_data = JSON.parse(result.data.task.form_data);
        this.$store.state.userFormSubmitArray = form_data;
        localStorage.setItem("activeFormId", formId);
        localStorage.setItem("activeFormSchema", form);
        localStorage.setItem("activeTaskStatus", result.data.task.task_status);

        let newRoute = "";
        if (formType == 1) {
          localStorage.setItem("taskFormData", result.data.task.form_data);
          newRoute = "/user-form";
        } else if (formType == 2) {
          newRoute = "/user-form";
        } else if (formType == 3) {
          newRoute = "/user-training";
        } else if (formType == 4) {
          localStorage.setItem(
            "examAttemptsToDate",
            result.data.task.exam_attempts_count
          );
          newRoute = "/user-exam";
        }
        //window.open("http://localhost:1090"+newRoute,'','postwindow');
        this.$router.push({
          path: newRoute,
          params: {
            from: "/mytpp"
          }
        });
      }
    }
  }
};
</script>

<style scoped>
</style>
